import { ContestStatus } from '@betterpool/api-types/contests-service';

import useIsUserAdmin from '~/domains/payments/hooks/useIsUserAdmin';

import { useContest } from '../../../hooks/useContest';
import type { FullContest } from '../../services/interfaces/full-contest.interface';

type UseEntryCancellableProps =
  | {
      fullContest: FullContest;
    }
  | {
      contestId: string;
    };

export const useIsEntryWithdrawalAllowed = (props: UseEntryCancellableProps) => {
  const isContestIdProvided = 'contestId' in props;
  const contest = useContest(isContestIdProvided && props.contestId, isContestIdProvided);
  const fullContest = isContestIdProvided ? contest?.data : props.fullContest;

  const isContestScheduled = fullContest?.status === ContestStatus.SCHEDULED;
  const isContestFilled = fullContest?.entries.max === fullContest?.entries.filled;
  const isUserAdmin = useIsUserAdmin();

  const isEntryWithdrawalAllowed = isContestScheduled && (!isContestFilled || isUserAdmin);

  return {
    isEntryWithdrawalAllowed,
  };
};
